@if (!loading) {
  <table>
    <thead>
    <ng-content select="[pre-header]"></ng-content>
    <tr>
      @for (column of visibleColumns; track column) {
        <th [class]="column.cellClasses" scope="col">{{column.title}}</th>
      }
    </tr>
    <ng-content select="[post-header]"></ng-content>
    </thead>
    <tbody>
    @for (row of rows; track row) {
      <tr (click)="editClicked(row)" [class.clickable]="editable">
        @for (column of visibleColumns; track column) {
          <td [class]="column.cellClasses">
            @switch (column.columnType) {
              @case (ColumnType.Text) {
                @if (!column.useFallback(row)) {
                  @switch (column.config.format) {
                    @case (TextColumnFormat.NoFormat) {
                      {{column.display(row)}}
                    }
                    @case (TextColumnFormat.TitleCase) {
                      {{column.display(row) | titlecase}}
                    }
                    @case (TextColumnFormat.Date) {
                      {{column.display(row) | date:dateFormat}}
                    }
                    @case (TextColumnFormat.Link) {
                      <a [routerLink]="column.config.routerLink(row)">
                        {{column.display(row)}}
                      </a>
                    }
                  }
                } @else {
                  <span class="fallback">{{column.fallback}}</span>
                }
              }
              @case (ColumnType.List) {
                @if (!column.useFallback(row)) {
                  {{column.display(row)}}
                } @else {
                  <span class="fallback">{{column.fallback}}</span>
                }
              }
              @case (ColumnType.Button) {
                <button class="btn" [class]="column.buttonClasses" (click)="column.click($event, row)" [disabled]="column.isDisabled(row)">
                  {{column.label}}
                </button>
              }
              @case (ColumnType.Template) {
                <ng-container
                  [ngTemplateOutlet]="column.getTemplateRef()"
                  [ngTemplateOutletContext]="column.getContext(row)"
                ></ng-container>
              }
              @default {
                ⚠️ ColumnType "{{ column.columnType }}" not recognised
              }
            }
          </td>
        }
        @if (editable) {
          <td class="icon">
            <img role="button" alt="Edit" title="Edit" src="/assets/default/right.svg" tabindex="0">
          </td>
        }
        @if (deletable) {
          <td class="icon cell--delete" (click)="preventBubbling($event)">
            <button type="button" class="btn btn-clear delete-button" [disabled]="!deleteEnabled(row)" (click)="deleteClicked(row)">
              <img alt="Delete" src="/assets/default/trash.svg">
            </button>
          </td>
        }
      </tr>
    }
    </tbody>
  </table>
}

@if (!error && loading) {
  <div class="table-message">
    <span>{{loadingMessage}}</span>
  </div>
}

@if (error) {
  <div class="table-message">
    <span>{{error}}</span>
  </div>
} @else {
  @if (empty) {
    <div class="table-message">
      <span>{{emptyMessage}}</span>
    </div>
  }
}

@if (pages.numberElements > 0) {
  <app-paginator
    [pages]="pages"
    (page)="page.emit()">
  </app-paginator>
}
